import React from "react";
import { Props } from "./types";

function MoreIcon(props: Props) {
  return (
    <svg className={props.className} viewBox="0 0 25.975 6.494">
      <path
        id="Icon_material-more-horiz"
        d="M9.247,15a3.247,3.247,0,1,0,3.247,3.247A3.256,3.256,0,0,0,9.247,15Zm19.481,0a3.247,3.247,0,1,0,3.247,3.247A3.256,3.256,0,0,0,28.728,15Zm-9.741,0a3.247,3.247,0,1,0,3.247,3.247A3.256,3.256,0,0,0,18.988,15Z"
        transform="translate(-6 -15)"
      />
    </svg>
  );
}

export { MoreIcon };
